import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type UserPreferencesState = {
  gibimotchi: boolean;
  updateUserPreferences: (params: Partial<Pick<UserPreferencesState, 'gibimotchi'>>) => void;
};

export const useUserPreferencesState = create<UserPreferencesState>()(
  persist(
    (set) => ({
      gibimotchi: false,
      updateUserPreferences: (params) => set(params),
    }),
    { name: 'user-preferences' },
  ),
);
